const { useLocation } = require('react-router-dom');
import React from 'react';

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

export { useQuery };
